module.exports = __webpack_public_path__ + "media/application/images/ui/logo-no-strap-header@x2-686f8cf573104a2e0060d65344642046.png";